import util from '../../lib/util';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from "../find";
import Lead from '../../entities/lead';
import Matter from '../../entities/matter';
import Invoice from '../../entities/invoice';
import Referral from '../../entities/referral';
import Task from '../../entities/task';
import Document from '../../entities/document';
import Comment from '../../entities/comment';
import Participant from '../../entities/participant';
import RedFlag from '../../entities/redFlag';
import Milestone from '../../entities/milestone';

/*
 * Delete/nullify anywhere this lead is used in other entities
 *
 * @param {Lead} lead
 */
export function deleteLead(lead: Lead, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = lead.id;
    }
    /* Simple delete usages */
        
    store.getState().matters
        .getMappingFor('leadId', lead.id)
        .filter(matterTemp => matterTemp.status !== 'D')
        .forEach(matterTemp => {
            const _matter = matterTemp.clone();
            _matter.status =  'U';
            _matter.addedOn = newHRTimestamp();
            _matter.addedBy = getCurrentUserId();
            _matter.importSource = targetImportSource;
            _matter.importId = mergeId;

            _matter.leadId = null;
            store.dispatch(Actions.MatterActions.saveMatterQueue(_matter));
        });

    store.getState().invoices
        .getMappingFor('leadId', lead.id)
        .filter(invoiceTemp => invoiceTemp.status !== 'D')
        .forEach(invoiceTemp => {
            const _invoice = invoiceTemp.clone();
            _invoice.status =  'U';
            _invoice.addedOn = newHRTimestamp();
            _invoice.addedBy = getCurrentUserId();
            _invoice.importSource = targetImportSource;
            _invoice.importId = mergeId;

            _invoice.leadId = null;
            store.dispatch(Actions.InvoiceActions.saveInvoiceQueue(_invoice));
        });

    store.getState().referrals
        .getMappingFor('leadId', lead.id)
        .filter(referralTemp => referralTemp.status !== 'D')
        .forEach(referralTemp => {
            const _referral = referralTemp.clone();
            _referral.status =  'U';
            _referral.addedOn = newHRTimestamp();
            _referral.addedBy = getCurrentUserId();
            _referral.importSource = targetImportSource;
            _referral.importId = mergeId;

            _referral.referral = '';
            store.dispatch(Actions.ReferralActions.saveReferralQueue(_referral));
        });

    /* Complex delete usages */
        /* - Delete embedded key/value usages */
    
    findAll<Task>('tasks')
        // Has to have the tieIns property
        .filter(taskTemp => taskTemp.status !== 'D' && taskTemp.hasOwnProperty('tieIns'))
        // Has to have a tieIns with a key/value pair that matches
        .filter(taskTemp => !!taskTemp.tieIns?.some(f => {
            return 'Lead' === f.entity && f.id === lead.id;
        }))
        // For each task, go through tieIns and delete entries with the key/value pair
        .forEach(taskTemp => {
            const _task = taskTemp.clone();
            _task.tieIns = [...(taskTemp.tieIns || [])]
                .filter(f => !('Lead' === f.entity && f.id === lead.id));
            _task.status = 'U';
            _task.addedOn = newHRTimestamp();
            _task.addedBy = getCurrentUserId();
            _task.importSource = targetImportSource;
            _task.importId = mergeId;
            store.dispatch(Actions.TaskActions.saveTaskQueue(_task));
        });

    /* Remove the actual lead */
    lead.status = 'D';
    lead.addedOn = newHRTimestamp();
    lead.addedBy = getCurrentUserId();
    lead.importSource = targetImportSource;
    lead.importId = mergeId;
    store.dispatch(Actions.LeadActions.removeLeadQueue(lead));
    

    /* Delete any documents */
    findAll<Document>('documents')
         .filter(documentTemp => documentTemp.entityType === 'lead' && documentTemp.entityId === lead.id && documentTemp.status !== 'D')
         .forEach(documentTemp => {
            const _document = documentTemp.clone();
            // Delete the target
            _document.status = 'D';
            _document.addedOn = newHRTimestamp();
            _document.addedBy = getCurrentUserId();
            _document.importSource = targetImportSource;
            _document.importId = mergeId;
            store.dispatch(Actions.DocumentActions.removeDocumentQueue(_document));
         });
    

    /* Delete any comments */
    findAll<Comment>('comments')
         .filter(commentTemp => commentTemp.entityType === 'lead' && commentTemp.entityId === lead.id && commentTemp.status !== 'D')
         .forEach(commentTemp => {
            const _comment = commentTemp.clone();
            // Delete the target
            _comment.status = 'D';
            _comment.addedOn = newHRTimestamp();
            _comment.addedBy = getCurrentUserId();
            _comment.importSource = targetImportSource;
            _comment.importId = mergeId;
            store.dispatch(Actions.CommentActions.removeCommentQueue(_comment));
         });
    

    /* Delete any participants */
    findAll<Participant>('participants')
         .filter(participantTemp => participantTemp.entityType === 'lead' && participantTemp.entityId === lead.id && participantTemp.status !== 'D')
         .forEach(participantTemp => {
            const _participant = participantTemp.clone();
            // Delete the target
            _participant.status = 'D';
            _participant.addedOn = newHRTimestamp();
            _participant.addedBy = getCurrentUserId();
            _participant.importSource = targetImportSource;
            _participant.importId = mergeId;
            store.dispatch(Actions.ParticipantActions.removeParticipantQueue(_participant));
         });
    

    /* Delete any redFlags */
    findAll<RedFlag>('redFlags')
         .filter(redFlagTemp => redFlagTemp.entityType === 'lead' && redFlagTemp.entityId === lead.id && redFlagTemp.status !== 'D')
         .forEach(redFlagTemp => {
            const _redFlag = redFlagTemp.clone();
            // Delete the target
            _redFlag.status = 'D';
            _redFlag.addedOn = newHRTimestamp();
            _redFlag.addedBy = getCurrentUserId();
            _redFlag.importSource = targetImportSource;
            _redFlag.importId = mergeId;
            store.dispatch(Actions.RedFlagActions.removeRedFlagQueue(_redFlag));
         });
    

    /* Delete any milestones */
    findAll<Milestone>('milestones')
         .filter(milestoneTemp => milestoneTemp.entityType === 'lead' && milestoneTemp.entityId === lead.id && milestoneTemp.status !== 'D')
         .forEach(milestoneTemp => {
            const _milestone = milestoneTemp.clone();
            // Delete the target
            _milestone.status = 'D';
            _milestone.addedOn = newHRTimestamp();
            _milestone.addedBy = getCurrentUserId();
            _milestone.importSource = targetImportSource;
            _milestone.importId = mergeId;
            store.dispatch(Actions.MilestoneActions.removeMilestoneQueue(_milestone));
         });
    
}

/*
 * Replace anywhere this lead is used in other entities.
 *
 * @param {Lead} lead
 * @param {Lead} replaceWith
 * @return {Lead} - Lead will have refs stripped away
 */
export function replaceLead(lead: Lead, replaceWith: Lead, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = lead.id;
    }
    /* Simple replace usages */
        
    store.getState().matters
        .getMappingFor('leadId', lead.id)
        .filter(matterTemp => matterTemp.status !== 'D')
        .forEach(matterTemp => {
            const _matter = matterTemp.clone();
            _matter.status =  'U';
            _matter.addedOn = newHRTimestamp();
            _matter.addedBy = getCurrentUserId();
            _matter.importSource = targetImportSource;
            _matter.importId = mergeId;

            _matter.leadId = replaceWith.id;
            store.dispatch(Actions.MatterActions.saveMatterQueue(_matter));
        });

    store.getState().invoices
        .getMappingFor('leadId', lead.id)
        .filter(invoiceTemp => invoiceTemp.status !== 'D')
        .forEach(invoiceTemp => {
            const _invoice = invoiceTemp.clone();
            _invoice.status =  'U';
            _invoice.addedOn = newHRTimestamp();
            _invoice.addedBy = getCurrentUserId();
            _invoice.importSource = targetImportSource;
            _invoice.importId = mergeId;

            _invoice.leadId = replaceWith.id;
            store.dispatch(Actions.InvoiceActions.saveInvoiceQueue(_invoice));
        });

    store.getState().referrals
        .getMappingFor('leadId', lead.id)
        .filter(referralTemp => referralTemp.status !== 'D')
        .forEach(referralTemp => {
            const _referral = referralTemp.clone();
            _referral.status =  'U';
            _referral.addedOn = newHRTimestamp();
            _referral.addedBy = getCurrentUserId();
            _referral.importSource = targetImportSource;
            _referral.importId = mergeId;

            _referral.referral = replaceWith.id;
            store.dispatch(Actions.ReferralActions.saveReferralQueue(_referral));
        });

    /* Complex replace usages */
        /* - Modify embedded key/value usages */
    
    findAll<Task>('tasks')
        // Has to have the tieIns property
        .filter(taskTemp => taskTemp.status !== 'D' && taskTemp.hasOwnProperty('tieIns'))
        // Has to have a tieIns with a key/value pair that matches
        .filter(taskTemp => !!taskTemp.tieIns?.some(f => {
            return 'Lead' === f.entity && f.id === lead.id;
        }))
        // For each task, go through tieIns and replace entries with the key/value pair
        .forEach(taskTemp => {
            const _task = taskTemp.clone();
            _task.tieIns = [...(taskTemp.tieIns || [])]
                .map(f => {
                        if('Lead' === f.entity && f.id === lead.id) {
                            const _f = {...f};
                            _f.id = replaceWith.id;
                            return _f;
                        }
                        else return f;
                    });
            _task.status = 'U';
            _task.addedOn = newHRTimestamp();
            _task.addedBy = getCurrentUserId();
            _task.importSource = targetImportSource;
            _task.importId = mergeId;
            store.dispatch(Actions.TaskActions.saveTaskQueue(_task));
        });

    /* Move any documents */
    findAll<Document>('documents')
         .filter(documentTemp => documentTemp.entityType === 'lead' && documentTemp.entityId === lead.id && documentTemp.status !== 'D')
         .forEach(documentTemp => {
            const _document = documentTemp.clone();
            // Replace the target with the new ID
			_document.entityId = replaceWith.id;
            _document.status = 'U';
            _document.addedOn = newHRTimestamp();
            _document.addedBy = getCurrentUserId();
            _document.importSource = targetImportSource;
            _document.importId = mergeId;
            store.dispatch(Actions.DocumentActions.saveDocumentQueue(_document));
         });
    

    /* Move any comments */
    findAll<Comment>('comments')
         .filter(commentTemp => commentTemp.entityType === 'lead' && commentTemp.entityId === lead.id && commentTemp.status !== 'D')
         .forEach(commentTemp => {
            const _comment = commentTemp.clone();
            // Replace the target with the new ID
			_comment.entityId = replaceWith.id;
            _comment.status = 'U';
            _comment.addedOn = newHRTimestamp();
            _comment.addedBy = getCurrentUserId();
            _comment.importSource = targetImportSource;
            _comment.importId = mergeId;
            store.dispatch(Actions.CommentActions.saveCommentQueue(_comment));
         });
    

    /* Move any participants */
    findAll<Participant>('participants')
         .filter(participantTemp => participantTemp.entityType === 'lead' && participantTemp.entityId === lead.id && participantTemp.status !== 'D')
         .forEach(participantTemp => {
            const _participant = participantTemp.clone();
            // Replace the target with the new ID
			_participant.entityId = replaceWith.id;
            _participant.status = 'U';
            _participant.addedOn = newHRTimestamp();
            _participant.addedBy = getCurrentUserId();
            _participant.importSource = targetImportSource;
            _participant.importId = mergeId;
            store.dispatch(Actions.ParticipantActions.saveParticipantQueue(_participant));
         });
    

    /* Move any redFlags */
    findAll<RedFlag>('redFlags')
         .filter(redFlagTemp => redFlagTemp.entityType === 'lead' && redFlagTemp.entityId === lead.id && redFlagTemp.status !== 'D')
         .forEach(redFlagTemp => {
            const _redFlag = redFlagTemp.clone();
            // Replace the target with the new ID
			_redFlag.entityId = replaceWith.id;
            _redFlag.status = 'U';
            _redFlag.addedOn = newHRTimestamp();
            _redFlag.addedBy = getCurrentUserId();
            _redFlag.importSource = targetImportSource;
            _redFlag.importId = mergeId;
            store.dispatch(Actions.RedFlagActions.saveRedFlagQueue(_redFlag));
         });
    

    /* Move any milestones */
    findAll<Milestone>('milestones')
         .filter(milestoneTemp => milestoneTemp.entityType === 'lead' && milestoneTemp.entityId === lead.id && milestoneTemp.status !== 'D')
         .forEach(milestoneTemp => {
            const _milestone = milestoneTemp.clone();
            // Replace the target with the new ID
			_milestone.entityId = replaceWith.id;
            _milestone.status = 'U';
            _milestone.addedOn = newHRTimestamp();
            _milestone.addedBy = getCurrentUserId();
            _milestone.importSource = targetImportSource;
            _milestone.importId = mergeId;
            store.dispatch(Actions.MilestoneActions.saveMilestoneQueue(_milestone));
         });
    
    return lead;
}

/*
 * Determine the impact of deleting this lead from other entities
 *
 * @param {Lead} lead
 * @return {Array.<{count: number, entity: string}>} - a list of impacted entities, along with a count of impacted entities
 */
export function deleteImpactLead(lead: Lead) {
    const impacts: string[] = [];
    const state = store.getState();
    
    /* Simple delete usages */
        
    const matterLeadIdImpact = state.matters
          .getMappingFor('leadId', lead.id)
          .filter(matter => matter.status !== 'D');

    matterLeadIdImpact.forEach(() => impacts.push('matters'));

    const invoiceLeadIdImpact = state.invoices
          .getMappingFor('leadId', lead.id)
          .filter(invoice => invoice.status !== 'D');

    invoiceLeadIdImpact.forEach(() => impacts.push('invoices'));

    const referralReferralImpact = state.referrals
          .getMappingFor('leadId', lead.id)
          .filter(referral => referral.status !== 'D');

    referralReferralImpact.forEach(() => impacts.push('referrals*'));

    /* Complex delete usages */
        /* - Impact embedded key/value usages */
    
    const taskTieInsImpact = findAll<Task>('tasks')
		.filter(task => task.status !== 'D' && task.hasOwnProperty('tieIns'))
		.filter(task => !!task.tieIns?.some(f => {
				return 'Lead' === f.entity && f.id === lead.id;
			}));
    taskTieInsImpact.forEach(() => impacts.push('tasks'));

    return util.countDistinct(impacts);
}